import { createRouter, createWebHistory } from 'vue-router';
import { useAuthStore } from '../stores/auth';

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('../views/Login.vue'),
    meta: { public: true, layout: 'blank' }
  },
  {
    path: '/',
    name: 'workspace',
    component: () => import('../views/Workspace.vue'),
    meta: { layout: 'main' }
  },
  {
    path: '/video-examples',
    name: 'video-examples',
    component: () => import('../views/VideoExamples.vue'),
    meta: { layout: 'main' }
  },
  {
    path: '/assets',
    name: 'assets',
    component: () => import('../views/Assets.vue'),
    meta: { layout: 'main' }
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/Settings.vue'),
    meta: { layout: 'main' }
  },
  {
    path: '/credits',
    name: 'credits',
    component: () => import('../views/Credits.vue'),
    meta: { layout: 'main' }
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/Admin.vue'),
    meta: { layout: 'main', requiresAdmin: true }
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('../views/Dashboard.vue'),
    meta: { layout: 'main', requiresAdmin: true }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/NotFound.vue'),
    meta: { layout: 'blank' }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    return { top: 0 };
  }
});

router.beforeEach(async (to) => {
  const auth = useAuthStore();
  // 没缓存且没初始化时才阻塞性等：默认情况下缓存已在 state 初始化中读完
  if (!auth.initialized && !auth.user) {
    await auth.checkSession().catch(() => {});
  }
  if (to.meta.public) return true;
  if (!auth.isAuthenticated) {
    return { name: 'login', query: { next: to.fullPath } };
  }
  if (to.meta.requiresAdmin && !auth.isAdmin) {
    return { name: 'workspace' };
  }
  return true;
});

export default router;
